import axios from 'axios'
import useAuthStore from '@/stores/auth'

const API_URL = process.env.VUE_APP_HOST_DOMAIN + process.env.VUE_APP_BASE_API
const headers = {
    'Content-Type': 'application/json; charset=utf-8'
}
const formDataHeaders = {
    'Content-Type': 'multipart/form-data'
}
export default {
    post(urlPath, data) {
        return this.request(urlPath, 'POST', headers, data)
    },
    put(urlPath, data) {
        return this.request(urlPath, 'PUT', headers, data)
    },
    get(urlPath) {
        return this.request(urlPath, 'GET', headers, null)
    },
    delete(urlPath) {
        return this.request(urlPath, 'DELETE', headers, null)
    },
    getFile(urlPath) {
        window.open(API_URL + urlPath, '_blank')
    },
    uploadFile(urlPath, formData) {
        return this.request(urlPath, 'POST', formDataHeaders, formData)
    },
    request(urlPath, method, headers, data, config) {
        data = data || {}
        const authStore = useAuthStore()
        const apiToken = authStore.getToken
        if (apiToken) {
            headers = {
                ...headers
            }
            if (urlPath !== 'users/login') {
                headers.Authorization = 'Bearer ' + apiToken
            }
        }
        return new Promise((resolve, reject) => {
            axios({
                url: API_URL + '/' + urlPath,
                data: data,
                method: method,
                headers: headers,
                ...config
            })
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }
}
